import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  RunTransition,
  RunTransitionWithDialog,
  WorkflowService,
} from 'src/app/shared/services/workflow/workflow.service';
import { PayeePopupComponent } from '../../payee-popup/payee-popup.component';
import { PayeeIconComponent } from '../../payee-icon/payee-icon.component';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { TranslateModule } from '@ngx-translate/core';

type DialogData = {
  transition_ids: {
    approve: string;
    reject: string;
  };
};

@Component({
  selector: 'app-hard-payment-plan-approve-dialog',
  templateUrl: './hard-payment-plan-approve-dialog.component.html',
  styleUrls: ['./hard-payment-plan-approve-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeIconComponent,
    PayeeButtonComponent,
    TranslateModule,
  ],
})
export class HardPaymentPlanApproveDialogComponent implements OnInit {
  private dialogRef =
    inject<MatDialogRef<HardPaymentPlanApproveDialogComponent>>(MatDialogRef);
  private data = inject<RunTransitionWithDialog>(MAT_DIALOG_DATA);
  private workflowService = inject(WorkflowService);

  loading = false;
  dialogData?: DialogData;

  async ngOnInit() {
    this.dialogData = (await this.workflowService.getDialogData({
      caseId: this.data.caseId,
      transitionId: this.data.transitionId,
    })) as DialogData;
  }

  readonly cancel = () => {
    this.dialogRef.close();
  };

  readonly submit = async (action: 'approve' | 'reject') => {
    if (!this.dialogData) {
      return;
    }

    const transitionId =
      action === 'approve'
        ? this.dialogData.transition_ids.approve
        : this.dialogData.transition_ids.reject;

    const closeValue: RunTransition = {
      ...(this.data.extraParams ?? {}),
      caseId: this.data.caseId,
      transitionId,
    };

    this.loading = true;
    try {
      await this.workflowService.runTransition(closeValue);
      this.dialogRef.close(closeValue);
    } catch (error) {
      this.workflowService.showTransitionError(error);
    } finally {
      this.loading = false;
    }
  };
}
